const formatters = {
  formatDecimal(value) {
    return new Intl.NumberFormat('id-ID', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  },
  // Add-on gratis tampil "Free", bukan "0" — dipakai semua permukaan add-on customer.
  formatAddOnPrice(value) {
    return Number(value) > 0 ? formatters.formatDecimal(value) : 'Free';
  },
  formatCurrency(value) {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value).replace('Rp', 'IDR');
  },
  formatDate(value) {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      // console.error("Invalid date value:", value);
      return "Invalid Date"; // Kembalikan string default jika value tidak valid
    }
    return new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(date);
  },
  formatLongDate(value) {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      // console.error("Invalid date value:", value);
      return "Invalid Date"; // Kembalikan string default jika value tidak valid
    }
    return new Intl.DateTimeFormat('en-GB', {
      weekday: 'short', // Hari dalam format singkat (misal: Mon)
      day: 'numeric',   // Tanggal (misal: 12)
      month: 'short',   // Bulan singkat (misal: Sep)
      year: 'numeric',  // Tahun lengkap (misal: 2024)
      hour: '2-digit',  // Jam dengan dua digit (misal: 08)
      minute: '2-digit', // Menit dengan dua digit (misal: 30)
      hour12: false     // Format 24 jam (true untuk format 12 jam)
    }).format(date);
  },
  formatShortDate(value) {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      // console.error("Invalid date value:", value);
      return "Invalid Date"; // Kembalikan string default jika value tidak valid
    }
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(date);
  },
  formatDateStay(value) {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      // console.error("Invalid date value:", value);
      return "Invalid Date"; // Kembalikan string default jika value tidak valid
    }
    return new Intl.DateTimeFormat('en-GB', {
      // weekday: 'short', // Hari dalam format singkat (misal: Mon)
      day: 'numeric',   // Tanggal (misal: 12)
      month: 'short',   // Bulan singkat (misal: Sep)
      year: 'numeric',  // Tahun lengkap (misal: 2024)
      hour: '2-digit',  // Jam dengan dua digit (misal: 08)
      minute: '2-digit', // Menit dengan dua digit (misal: 30)
      hour12: false     // Format 24 jam (true untuk format 12 jam)
    }).format(date);
  },
  formatTime(value) {
    if (!value || typeof value !== 'string') {
      // console.error("Invalid time value:", value);
      return "Invalid Time"; // Fallback jika value tidak valid
    }
    const [hours, minutes] = value.split(":");
    return `${hours}:${minutes}`;
  },
};

export default {
  install(app) {
    app.config.globalProperties.$formatters = formatters;
  },
};